import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { Settings } from 'luxon';

import * as Sentry from '@sentry/angular';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { MAT_CHECKBOX_DEFAULT_OPTIONS } from '@angular/material/checkbox';
import {
  MatFormFieldModule,
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
} from '@angular/material/form-field';
import { MatLuxonDateModule } from '@angular/material-luxon-adapter';

import { PlUtilsModule, PlAuthModule } from 'pl-core-services';

import { PlEntityStoreModule } from '@common/entities/pl-entity-store.module';

import { RouterModule } from '@angular/router';
import { ProviderWorkspaceModule } from '@app/workspace/provider-workspace.module';
import { HijackComponent } from '@app/hijack/hijack.component';
import { AuthModule } from '@app/auth/auth.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { layoutDefaults } from './layout/constants';
import { PlRootComponent } from './root/pl-root.component';
import { PendoLogger } from './common/pendo.service';
import { HeapLogger } from './common/heap.service';
import { SubscriptionStoreModule } from './subscription/store';

@NgModule({
  declarations: [AppComponent, PlRootComponent, HijackComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    PlEntityStoreModule,
    SubscriptionStoreModule,
    StoreDevtoolsModule.instrument({
      maxAge: 50,
      // logOnly: environment.production, // Restrict extension to log-only mode
      connectInZone: true,
    }),
    AppRoutingModule,
    ProviderWorkspaceModule,
    // Angular Material
    MatIconModule,
    MatFormFieldModule,
    MatButtonModule,
    MatLuxonDateModule,
    MatSidenavModule,
    LayoutModule,
    PlUtilsModule,
    PlAuthModule,
    AuthModule,
    RouterModule,
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: layoutDefaults.formField,
    },
    {
      provide: MAT_RADIO_DEFAULT_OPTIONS,
      // todo use material theme instead (pl-colors.scss)
      useValue: { color: 'primary' },
    },
    {
      provide: MAT_CHECKBOX_DEFAULT_OPTIONS,
      // todo use material theme instead (pl-colors.scss)
      useValue: { color: 'primary' },
    },
    PendoLogger,
    HeapLogger,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        logErrors: true,
      }),
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(iconRegistry: MatIconRegistry) {
    iconRegistry.setDefaultFontSetClass('material-icons-outlined');
    Settings.defaultLocale = 'en-US';
  }
}
